<template>
  <section>
    <div class="flex mb-4 max-lg:mb-2">
      <GfrNewButton class="app-toggle-btn flex-shrink-0 lg:!hidden" @click="toggleDocumentMenu">
        <IconsReturn class="h-4 w-4" />
      </GfrNewButton>
      <Breadcrumb v-if="routePath" class="breadcrumb-container">
        <BreadcrumbList class="breadcrumb-list">
          <template v-for="(item, index) in routePath.slice(0, routePath.length - 1)" :key="index">
            <BreadcrumbSeparator v-if="index != 0" class="breadcrumb-separator"> / </BreadcrumbSeparator>
            <BreadcrumbItem class="breadcrumb-item">
              <NuxtLink v-if="item.url" class="breadcrumb-link" :to="`${prefixPath}/${item.url}/`">
                {{ item.title }}
              </NuxtLink>
              <span v-else class="breadcrumb-text">
                {{ item.title }}
              </span>
            </BreadcrumbItem>
          </template>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
    <slot />
  </section>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { CatalogsConfig } from '~/components/gfr/types/components'
defineProps({
  routePath: { type: Array as PropType<CatalogsConfig[]>, default: () => [] },
  prefixPath: { type: String, default: '' }
})
const documentStore = useDocumentStore()
const { toggleDocumentMenu } = documentStore
</script>
<style scoped lang="scss">
.app-toggle-btn {
  @apply inline-flex z-10 h-8 w-8 bg-dark-background ltr:mr-2 rtl:ml-2;
}

.breadcrumb {
  &-container {
    @apply max-lg:min-h-8 flex items-center;
  }
  &-list {
    @apply gap-0 text-m-p text-[#707070] max-lg:text-xs max-lg:leading-4.5;
  }
  &-separator {
    @apply leading-5;
  }
  &-link {
    @apply transition-colors hover:text-primary;
  }
  &-text {
    @apply cursor-default;
  }
  &-item {
    @apply last:text-white capitalize mx-2 lg:first:ml-0;
  }
}
</style>
